import { memo } from 'react';
import { StoreSelect } from './components/StoreSelect';
import { CategorySelect } from './components/CategorySelect';
import { LabelSelect } from './components/LabelSelect';
import { KeywordSelect } from './components/KeywordSelect';
import { SpuClassSelect } from './components/SpuClassSelect';
import { useItemContext } from './Context';

interface SearchCompProps {
  showSpuClassSelect?: boolean;
}

export const SearchComp = memo((props: SearchCompProps) => {
  const { showSpuClassSelect = false } = props;

  const { bindItem } = useItemContext();

  return (
    <div className="flex gap-[12px] bg-[#fff] px-[16px] py-[14px] flex-shrink-0">
      <StoreSelect />
      <CategorySelect />
      <LabelSelect />
      {showSpuClassSelect && <SpuClassSelect />}
      {!bindItem && <KeywordSelect />}
    </div>
  );
});

SearchComp.displayName = 'ItemSelectV5SearchComp';
